module.exports = __webpack_public_path__ + "static/img/jinxuan.ada926d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/jinxuan.png
// module id = 4Xnt
// module chunks = 1